var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
var BadeView = /** @class */ (function (_super) {
    __extends(BadeView, _super);
    function BadeView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BadeView.prototype.calcLeft = function () {
        var amountOfDigits = Math.max(Math.min(Math.floor(Math.log10(Math.abs(this.props.badge))) + 1, 1), 3);
        return (this.props.width - 23) + amountOfDigits * 2;
    };
    BadeView.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement("img", { src: this.props.icon, width: this.props.width }),
            Boolean(this.props.badge) &&
                React.createElement("span", { style: { left: this.calcLeft(), marginTop: '4px' }, className: "badge-number-view" }, this.props.badge)));
    };
    return BadeView;
}(React.PureComponent));
export default BadeView;
//# sourceMappingURL=BadgeView.js.map


//////////////////
// WEBPACK FOOTER
// ./bpm-web-generic/lib/components/BadgeView.js
// module id = 411
// module chunks = 0